// Configurazione runtime della UI di onboarding.
// In dev /api e' inoltrato dal proxy Vite; in produzione IIS espone /ttai/* verso FastAPI.
const viteEnv = import.meta.env || {}
export const API_BASE = viteEnv.DEV ? '' : '/ttai'

const API_KEY_STORAGE = 'ttai_onboarding_api_key'

export function getApiKey() {
  const envKey = viteEnv.VITE_TTAI_API_KEY || ''
  if (envKey) return envKey
  if (typeof window === 'undefined') return ''
  try { return window.sessionStorage.getItem(API_KEY_STORAGE) || '' }
  catch { return '' }
}

export function setApiKey(value) {
  if (typeof window === 'undefined') return
  try {
    const v = String(value || '').trim()
    if (v) window.sessionStorage.setItem(API_KEY_STORAGE, v)
    else window.sessionStorage.removeItem(API_KEY_STORAGE)
  } catch {}
}

// DPI del render pagina (soluzione A). scale px/punto = RENDER_DPI/72.
export const RENDER_DPI = 150
